import { gql } from '@apollo/client';
import { ERRORS_FRAGMENT } from '@/graphql/fragments';

export const POLICIES_QUERY = gql`
    ${ERRORS_FRAGMENT}
    query Policies($policyType: PolicyTypeEnum!) {
        policies(policyType: $policyType) {
            status
            errors {
                ...ErrorType
            }
            policies
        }
    }
`;
